module.exports = __webpack_public_path__ + "img/iso1328-1-2013_fig14_profile-excess.9444c8ff.png";